"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parseQuery = function () {
    var queryString = window.location.search.substring(1);
    return parsePairsFromString(queryString);
};
exports.parseQuery = parseQuery;
var parseHash = function () {
    var hashString = window.location.hash.substring(1);
    return parsePairsFromString(hashString);
};
exports.parseHash = parseHash;
// update a query param by providing key and value
var updateQueryParam = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.key, key = _c === void 0 ? '' : _c, _d = _b.value, value = _d === void 0 ? '' : _d;
    if (key) {
        var queryParams_1 = parseQuery();
        queryParams_1[key] = value;
        var queryParamsStr = Object.keys(queryParams_1)
            .map(function (paramKey) {
            var val = queryParams_1[paramKey];
            return paramKey + "=" + val;
        })
            .join('&');
        updateQueryParamInUrl(queryParamsStr);
    }
};
exports.updateQueryParam = updateQueryParam;
// update the entire query param string in the url
var updateQueryParamInUrl = function (queryParam) {
    if (queryParam === void 0) { queryParam = ''; }
    if (queryParam) {
        var newUrl = window.location.origin + window.location.pathname + '?' + queryParam;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
};
exports.updateQueryParamInUrl = updateQueryParamInUrl;
var parsePairsFromString = function (inputStr) {
    if (inputStr === void 0) { inputStr = ''; }
    var output = {};
    var pairs = inputStr.split('&');
    for (var _i = 0, pairs_1 = pairs; _i < pairs_1.length; _i++) {
        var item = pairs_1[_i];
        var pair = item.split('=');
        var key = decodeURIComponent(pair[0]);
        var value = decodeURIComponent(pair[1] || '');
        if (key) {
            output[key] = value;
        }
    }
    return output;
};
var updateKeyValuePairInQueryString = function (_a) {
    var queryString = _a.queryString, key = _a.key, value = _a.value;
    if (queryString && key) {
        var queryParams = parsePairsFromString(queryString);
        queryParams[key] = value.toString();
        var queryParamsStr = stringifyQueryParams(queryParams);
        return queryParamsStr;
    }
    return '';
};
exports.updateKeyValuePairInQueryString = updateKeyValuePairInQueryString;
var stringifyQueryParams = function (queryParams) {
    var queryParamsStr = Object.keys(queryParams)
        .map(function (paramKey) {
        var val = queryParams[paramKey];
        return paramKey + "=" + val;
    })
        .join('&');
    return queryParamsStr;
};
// update a hash param by providing key and value
var updateHashParam = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.key, key = _c === void 0 ? '' : _c, _d = _b.value, value = _d === void 0 ? '' : _d;
    if (key) {
        var hashParams_1 = parseHash();
        hashParams_1[key] = value;
        var queryParamsStr = Object.keys(hashParams_1)
            .map(function (paramKey) {
            var val = hashParams_1[paramKey];
            return paramKey + "=" + val;
        })
            .join('&');
        window.location.hash = queryParamsStr;
    }
};
exports.updateHashParam = updateHashParam;
